import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const BooksetList = ({ booksets }) => (
  <ul className={styles.booksetList}>
    {booksets.map((bookset, key) => {
      return bookset && (
        <li className={styles.booksetListItem} key={bookset && bookset.id ? bookset.id : key}>
          <Link to={bookset.absolute_url}>
            <div className="billetContainer">
              <div className={styles.bookset}>
                <div className={styles.booksetInfo}>
                  <big><b>{bookset.name}</b></big>
                  <span className={styles.booksetBookCount}>
                    {`${bookset.active_book_count} ${pluralize(bookset.active_book_count, 'книга', 'книги', 'книг')}`}
                  </span>
                </div>
                <CroppedImage
                  className={styles.booksetImage}
                  width={40}
                  height={40}
                  src={bookset.preview || bookset.picture}
                  alt={bookset.name} />
              </div>
            </div>
          </Link>
        </li>
      );
    })}
  </ul>
);

BooksetList.propTypes = {
  booksets: PropTypes.array.isRequired,
};

export default BooksetList;
